import React from 'react';
import { Helmet } from 'react-helmet-async';

export const OrganizationSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'TTA.games',
    url: 'https://www.tta.games',
    logo: 'https://www.tta.games/logo192.png',
    description:
      'Board game marketplace for buying, selling, and borrowing board games',
    sameAs: [] as string[],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

interface GameSchemaProps {
  name: string;
  description: string;
  image?: string;
  price?: number;
  condition?: string;
  category?: string;
}

export const GameProductSchema = ({
  name,
  description,
  image,
  price,
  condition,
  category,
}: GameSchemaProps) => {
  const conditionMap: Record<string, string> = {
    new: 'https://schema.org/NewCondition',
    like_new: 'https://schema.org/LikeNewCondition',
    good: 'https://schema.org/UsedCondition',
    acceptable: 'https://schema.org/DamagedCondition',
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    description,
    image,
    category: category || 'Board Games',
    offers: price
      ? {
          '@type': 'Offer',
          price,
          priceCurrency: 'USD',
          itemCondition:
            conditionMap[condition || 'good'] ||
            'https://schema.org/UsedCondition',
          availability: 'https://schema.org/InStock',
        }
      : undefined,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
